import React, { useState, useRef, useEffect } from "react";
import { Shuffle } from "lucide-react";
import { TRANSITIONS } from "../utils/transitions";
import TransitionPreviewCanvas from "./TransitionPreviewCanvas";

export default function TransitionBlock({ index, currentTransition, onChange, previewImages,onSelectTransition }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const imgA = previewImages[0];
  const imgB = previewImages[1] || previewImages[0];

return (
  <div className="relative flex items-center" ref={ref}>
    <button
      onClick={() => {
        onSelectTransition(index);
        setOpen(!open);
      }}
      className="
        px-2 py-1 text-xs rounded-md
        flex items-center gap-1
        bg-gray-200 hover:bg-gray-300
        dark:bg-gray-800 dark:hover:bg-gray-700
        border border-gray-300 dark:border-gray-700
        text-gray-900 dark:text-gray-200
        transition-colors
      "
    >
      <Shuffle size={12} />
      {currentTransition}
    </button>
  </div>
);

}
